import { FaCheck, FaRegHourglass } from "react-icons/fa";
import Message, { MessageProps } from "./Message";
import styles from "./Thread.module.css";
import classNames from "classnames";
import { MessagesId, MsgType, ThreadsId } from "cadendar-shared";
import { BsFillTelephoneForwardFill } from "react-icons/bs";
import MsgTextArea from "./MsgTextArea";

export interface ThreadProps {
  messages: (Omit<MessageProps, "onMessageClick" | "onPatientNameClick"> & {
    patient_id: string | null;
  })[];
  showReplyLink: boolean;

  isDoctor: boolean;
  onArchiveClick: (threadId: ThreadsId) => void;
  isResponding: boolean;
  threadId: ThreadsId;
  onMessageClick: (id: MessagesId) => void;
  onReplyClick: () => void;
  replyText: string;
  name: string;
  firstName: string;
  msgReplyType: MsgType;
  onReplySend: () => void;
  onReplyTextChange: (text: string) => void;
  onReplyCancel: () => void;
  onEmergencyClick: () => void;
  onQuestionClick: () => void;
  onCallClick: () => void;
  onWaitingClick: () => void;
  onDoneClick: () => void;
  onSelectPatientForMessage: () => void;
  onSelectPatient: (patientId: string) => void;
  onRespondReplayClick: (messageId: MessagesId) => void;
}
const Thread = (props: ThreadProps) => {
  const {
    messages,
    isDoctor,
    onArchiveClick,
    isResponding,
    threadId,
    onMessageClick,
    onReplyClick,
    replyText,
  } = props;
  const {
    onReplySend,
    onReplyTextChange,
    msgReplyType,
    onEmergencyClick,
    onQuestionClick,
    onCallClick,
    onWaitingClick,
    onDoneClick,
  } = props;
  const sortedMessages = messages.sort((a, b) => {
    return a.timestamp.getTime() - b.timestamp.getTime();
  });
  const responseComp = (
    <div>
      <MsgTextArea
        id="textarea_reply_message"
        value={replyText}
        onChange={onReplyTextChange}
        onSubmit={onReplySend}
        name={props.name}
        firstName={props.firstName}
        border="1px solid #000"
        onSelect={() => {
          props.onSelectPatientForMessage();
        }}
        onCancel={props.onReplyCancel}
      />
      <div className={styles.labelSpacer}>
        <label className={styles.label}>
          <input
            type="checkbox"
            id="urgentMessageCheck"
            checked={msgReplyType === "urgent"}
            onChange={onEmergencyClick}
            className={styles.cursorPointer}
          />
          Urgent
        </label>
        <label className={styles.label}>
          <input
            type="checkbox"
            id="questionMessageCheck"
            checked={msgReplyType === "question"}
            className={styles.cursorPointer}
            onChange={onQuestionClick}
          />
          Question
        </label>
        <label className={classNames(styles.label, styles.tooltip)}>
          <input
            type="checkbox"
            id="CallCheck"
            checked={msgReplyType === "call"}
            className={styles.cursorPointer}
            onChange={onCallClick}
          />
          <BsFillTelephoneForwardFill />
          <div className={styles.tooltiptext}>A appeler</div>
        </label>
        <label className={classNames(styles.label, styles.tooltip)}>
          <input
            type="checkbox"
            id="waitingCheck"
            checked={msgReplyType === "waiting"}
            className={styles.cursorPointer}
            onChange={onWaitingClick}
          />
          <FaRegHourglass color="orange" />
          <div className={styles.tooltiptext}>On attend</div>
        </label>
        <label className={classNames(styles.label, styles.tooltip)}>
          <input
            type="checkbox"
            id="doneCheck"
            checked={msgReplyType === "done"}
            className={styles.cursorPointer}
            onChange={onDoneClick}
          />
          <FaCheck color="green" />
          <div className={styles.tooltiptext}>Fait</div>
        </label>
      </div>
    </div>
  );
  const hasMessageNotSeen = messages.some((message) => message.notSeenByMe);
  return (
    <>
      <div
        className={classNames(styles.message, {
          [styles.message_not_seen]: hasMessageNotSeen,
        })}
        id={threadId.toString()}
      >
        {isDoctor ? (
          <div
            className={styles.archive_link}
            onClick={onArchiveClick.bind(null, threadId)}
          >
            Archiver
          </div>
        ) : null}
        {sortedMessages.map((message, idx) => (
          <Message
            {...{
              ...message,
              onMessageClick: () => onMessageClick(message.id),
              onPatientNameClick: () => {
                if (message.patient_id) {
                  props.onSelectPatient(message.patient_id);
                }
              },
              onRespondReplayClick: () => props.onRespondReplayClick(message.id),
            }}
            key={threadId + "_" + idx}
          />
        ))}

        {!isResponding && props.showReplyLink ? (
          <span className={styles.reply_link} onClick={onReplyClick}>
            Répondre
          </span>
        ) : null}

        {isResponding ? responseComp : null}
      </div>
    </>
  );
};

export default Thread;
